import { forwardRef } from 'react';

import NextImage, { ImageProps as NextImageProps } from 'next/image';

import { cn } from '@/lib/utils/cn';

export interface I_ImageProps extends Omit<NextImageProps, 'width' | 'height'> {
  className?: string;
  priority?: boolean;
  loading?: 'lazy' | 'eager';
  sizes?: string;
  width?: number;
  height?: number;
  quality?: number;
  placeholder?: 'blur' | 'empty';
  blurDataURL?: string;
}

export const Image = forwardRef<HTMLImageElement, I_ImageProps>(
  ({ className, placeholder = 'empty', width, height, alt, ...props }, ref) => {
    const imageAlt = alt || 'Image';
    const hasDimensions = !!width && !!height;

    return (
      <NextImage
        ref={ref}
        className={cn(
          hasDimensions ? 'h-auto w-auto' : 'w-full h-full object-contain',
          className
        )}
        placeholder={placeholder}
        alt={imageAlt}
        {...(hasDimensions ? { width, height } : { fill: true })}
        {...props}
      />
    );
  }
);

Image.displayName = 'Image';
